import { TFunction } from 'next-i18next';
import { useMemo } from 'react';
import { BookingStatusOption, PaymentItemStatusOptions } from '~graphql/__generated__/globalTypes';

const PaymentItemPaidStatus = [
  PaymentItemStatusOptions.PAID,
  PaymentItemStatusOptions.VOID,
  PaymentItemStatusOptions.WAIVED,
  PaymentItemStatusOptions.REFUNDED,
  PaymentItemStatusOptions.RETURNED,
  PaymentItemStatusOptions.TRANSFERRED,
  PaymentItemStatusOptions.DEPOSITED,
];

const BookingStatusCanceledAndPast = [BookingStatusOption.CANCELLED, BookingStatusOption.PAST];

const BookingStatusCanceledAndPastAndExpired = [
  BookingStatusOption.CANCELLED,
  BookingStatusOption.PAST,
  BookingStatusOption.EXPIRED,
];

const BookingStatusCanceledAndPastAndResident = [
  BookingStatusOption.RESIDENT,
  BookingStatusOption.CANCELLED,
  BookingStatusOption.PAST,
];

const BookingStatusProcesing = [
  BookingStatusOption.APPLIED,
  BookingStatusOption.ROOM_SELECTED,
  BookingStatusOption.SELECTION_COMPLETED,
  BookingStatusOption.DETAILS_COMPLETED,
  BookingStatusOption.TERMS_ACCEPTED,
];

const BookingStatusConfirmed = [
  BookingStatusOption.BOOKING_CONFIRMED,
  BookingStatusOption.BOOKING_COMPLETED,
];

const BookingStatusProcesingExcludeApplied = [
  BookingStatusOption.ROOM_SELECTED,
  BookingStatusOption.SELECTION_COMPLETED,
  BookingStatusOption.DETAILS_COMPLETED,
  BookingStatusOption.TERMS_ACCEPTED,
];

const NominationBookingStatusProcesing = [
  BookingStatusOption.APPLIED,
  BookingStatusOption.ROOM_SELECTED,
  BookingStatusOption.SELECTION_COMPLETED,
  BookingStatusOption.DETAILS_COMPLETED,
  BookingStatusOption.ENQUIRY,
];

const BookingStatusProcesingWithEnquiry = [BookingStatusOption.ENQUIRY, ...BookingStatusProcesing];

const BookingProcesingOrderStatus = [
  BookingStatusOption.TERMS_ACCEPTED,
  BookingStatusOption.DETAILS_COMPLETED,
  BookingStatusOption.SELECTION_COMPLETED,
  BookingStatusOption.ROOM_SELECTED,
  BookingStatusOption.APPLIED,
  BookingStatusOption.ENQUIRY,
];

const BookingPendingOrderStatus = [
  BookingStatusOption.BOOKING_COMPLETED,
  BookingStatusOption.BOOKING_CONFIRMED,
  BookingStatusOption.RESIDENT,
  BookingStatusOption.PAST,
  BookingStatusOption.CANCELLED,
];

const BookingCompletedStatus = [
  BookingStatusOption.BOOKING_COMPLETED,
  BookingStatusOption.RESIDENT,
  BookingStatusOption.PAST,
  BookingStatusOption.CANCELLED,
];

function useGetBookingStepTitle(status: BookingStatusOption | null, t: TFunction) {
  return useMemo(() => {
    switch (status) {
      case BookingStatusOption.ENQUIRY:
        return t('nomination.begin_booking');
      case BookingStatusOption.APPLIED:
        return t('select_bed');
      case BookingStatusOption.ROOM_SELECTED:
        return t('payment_plan.select');
      case BookingStatusOption.SELECTION_COMPLETED:
        return t('personal_details');
      case BookingStatusOption.DETAILS_COMPLETED:
        return t('checkout_card.tenancy_agreement');
      case BookingStatusOption.TERMS_ACCEPTED:
        return t('payment');
      default:
        return '';
    }
  }, [status, t]);
}

export {
  BookingCompletedStatus,
  BookingPendingOrderStatus,
  BookingProcesingOrderStatus,
  BookingStatusCanceledAndPast,
  BookingStatusCanceledAndPastAndExpired,
  BookingStatusCanceledAndPastAndResident,
  BookingStatusConfirmed,
  BookingStatusProcesing,
  BookingStatusProcesingExcludeApplied,
  BookingStatusProcesingWithEnquiry,
  NominationBookingStatusProcesing,
  PaymentItemPaidStatus,
  useGetBookingStepTitle,
};
